import { useRef } from 'react';
import ArrowIosRight from '@crehana/compass.icons.outline/ArrowIosRight';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Tooltip } from '@crehana/ui';
import { clsx } from 'clsx';
import { AuthUserRoleEnum } from "../../../../generated/graphql/types";
import { handleNavigation } from "../../../../shared/utils";
import { useSidebar } from "../../sidebar-context";
import { DecoratedIcon } from "./decorated-icon";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export var MenuLink = function MenuLink(_ref) {
  var currentActive = _ref.currentActive,
    onClickItem = _ref.onClickItem,
    onClickModule = _ref.onClickModule,
    menuLink = _ref.menuLink,
    isFooterLink = _ref.isFooterLink,
    sidebarType = _ref.sidebarType,
    centralizedId = _ref.centralizedId;
  var _useSidebar = useSidebar(),
    sidebarCollapsed = _useSidebar.sidebarCollapsed,
    isDark = _useSidebar.isDark;
  var icon = menuLink.icon,
    activeIcon = menuLink.activeIcon,
    decoratedIcon = menuLink.decoratedIcon;
  var Icon = activeIcon || icon;
  var userRole = sidebarType === 'admin' ? AuthUserRoleEnum.AuthRoleAdmin : AuthUserRoleEnum.AuthRoleUser;

  // const { generateUrl } = useGenerateTokenUrl(
  //   userRole,
  //   centralizedId || '',
  //   isProduction,
  // );

  var popperRef = useRef(null);
  var isLinkActive = menuLink !== null && menuLink !== void 0 && menuLink.code && currentActive !== null && currentActive !== void 0 && currentActive.code ? currentActive.code === menuLink.code : false;
  var textColor = clsx('group-hover:tw-text-primary-light-500 group-hover:dark:tw-text-secondary-dark-300', isLinkActive ? 'tw-text-primary-light-500 dark:tw-text-secondary-dark-300' : 'tw-text-neutral-light-700 dark:tw-text-neutral-dark-400');
  var iconColor = 'tw-text-primary-light-500 dark:tw-text-secondary-dark-300';
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx("li", {
      className: clsx('tw-relative tw-block tw-w-full tw-py-0.4', {
        'tw-px-1.2': !isFooterLink
      }),
      ref: popperRef,
      children: /*#__PURE__*/_jsx(Tooltip, {
        label: menuLink.tooltip || menuLink.label,
        position: "right",
        isDark: !isDark,
        hidden: !sidebarCollapsed,
        children: /*#__PURE__*/_jsxs("button", {
          className: clsx('tw-group tw-flex tw-items-center tw-rounded-0.8 tw-cursor-pointer', isLinkActive ? 'tw-bg-neutral-dark-200 dark:tw-bg-elevation-dark-03' : 'tw-bg-transparent hover:tw-bg-neutral-light-200 hover:dark:tw-bg-elevation-dark-02', sidebarCollapsed ? 'tw-justify-center tw-w-4.8 tw-h-4.8 tw-mx-auto' : 'tw-p-0.8 tw-w-full', !decoratedIcon && 'tw-h-4'),
          onClick: function onClick() {
            if (menuLink.type === 'module' && onClickModule) {
              onClickModule(menuLink);
            } else if (onClickItem) {
              handleNavigation({
                url: menuLink.url || '',
                centralizedId: centralizedId || '',
                userRole: userRole,
                onClickItem: onClickItem,
                openInNewTab: menuLink.openInNewTab || false
              });
            }
          },
          type: "button",
          children: [Icon && /*#__PURE__*/_jsx(_Fragment, {
            children: decoratedIcon ? /*#__PURE__*/_jsx(DecoratedIcon, {
              sidebarCollapsed: sidebarCollapsed,
              iconColor: iconColor,
              Icon: Icon
            }) : /*#__PURE__*/_jsx("div", {
              className: clsx('tw-flex tw-items-center tw-justify-center', !isFooterLink && ' tw-w-[28px] tw-h-[28px]', decoratedIcon && 'tw-border-solid tw-border-[0.5px] dark:tw-border-elevation-dark-04  tw-border-neutral-light-400'),
              children: /*#__PURE__*/_jsx(Icon, {
                size: sidebarCollapsed && !isFooterLink ? 20 : 16,
                className: clsx(textColor, 'tw-fill-current'),
                ignoreColor: true
              })
            })
          }), !sidebarCollapsed && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx("p", {
              className: clsx('tw-text-left tw-ml-0.8 tw-capitalize', isFooterLink ? 'tw-font-body5' : 'tw-font-subtitle5', textColor),
              children: menuLink.label
            }), menuLink.arrowDefault && /*#__PURE__*/_jsx(ArrowIosRight, {
              size: 20,
              className: clsx('tw-ml-auto', textColor)
            })]
          })]
        })
      })
    }, menuLink.label + menuLink.code)
  });
};